'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ActionMenuItem = require('./../ActionMenuItem');

var _ActionMenuItem2 = _interopRequireDefault(_ActionMenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Remove this file after `actions` prop is removed
var createActionMenuItems = function createActionMenuItems(actions, handleClose) {
    return actions.map(function (item, index) {
        return _react2.default.createElement(
            _ActionMenuItem2.default,
            {
                onClick: function onClick(e) {
                    return handleClose(e, item);
                },
                key: index,
                tabIndex: index === 0 ? 0 : -1
            },
            item.label
        );
    });
};

exports.default = createActionMenuItems;